export default __webpack_public_path__ + "static/media/art.f3a08419.jpeg";